// Hero crew — optimized responsive variants (480/640/768/1024/1280/1600)
import crew480Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-480.avif.asset.json";
import crew640Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-640.avif.asset.json";
import crew768Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-768.avif.asset.json";
import crew1024Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1024.avif.asset.json";
import crew1280Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1280.avif.asset.json";
import crew1600Avif from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1600.avif.asset.json";
import crew480Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-480.webp.asset.json";
import crew640Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-640.webp.asset.json";
import crew768Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-768.webp.asset.json";
import crew1024Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1024.webp.asset.json";
import crew1280Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1280.webp.asset.json";
import crew1600Webp from "@/assets/hero/destination-roofing-crew-citrus-county-fl-1600.webp.asset.json";

import metal640Avif from "@/assets/metal-roof-installation-citrus-county-fl-640.avif.asset.json";
import metal1024Avif from "@/assets/metal-roof-installation-citrus-county-fl-1024.avif.asset.json";
import metal1600Avif from "@/assets/metal-roof-installation-citrus-county-fl-1600.avif.asset.json";
import metal640Webp from "@/assets/metal-roof-installation-citrus-county-fl-640.webp.asset.json";
import metal1024Webp from "@/assets/metal-roof-installation-citrus-county-fl-1024.webp.asset.json";
import metal1600Webp from "@/assets/metal-roof-installation-citrus-county-fl-1600.webp.asset.json";

import white640Avif from "@/assets/white-metal-roof-crystal-river-fl-640.avif.asset.json";
import white1024Avif from "@/assets/white-metal-roof-crystal-river-fl-1024.avif.asset.json";
import white1600Avif from "@/assets/white-metal-roof-crystal-river-fl-1600.avif.asset.json";
import white640Webp from "@/assets/white-metal-roof-crystal-river-fl-640.webp.asset.json";
import white1024Webp from "@/assets/white-metal-roof-crystal-river-fl-1024.webp.asset.json";
import white1600Webp from "@/assets/white-metal-roof-crystal-river-fl-1600.webp.asset.json";

// Owner-supplied real project photos (WebP-only, 480/768/1200/1320)
import blue480 from "@/assets/destination-roofing-blue-metal-roof-lecanto-fl-480w.webp.asset.json";
import blue768 from "@/assets/destination-roofing-blue-metal-roof-lecanto-fl-768w.webp.asset.json";
import blue1200 from "@/assets/destination-roofing-blue-metal-roof-lecanto-fl-1200w.webp.asset.json";
import blue1320 from "@/assets/destination-roofing-blue-metal-roof-lecanto-fl-1320w.webp.asset.json";

import galv480 from "@/assets/destination-roofing-galvalume-metal-roof-inverness-fl-480w.webp.asset.json";
import galv768 from "@/assets/destination-roofing-galvalume-metal-roof-inverness-fl-768w.webp.asset.json";
import galv1200 from "@/assets/destination-roofing-galvalume-metal-roof-inverness-fl-1200w.webp.asset.json";
import galv1320 from "@/assets/destination-roofing-galvalume-metal-roof-inverness-fl-1320w.webp.asset.json";

// Owner + sales team — optimized responsive variants (360/480/640/768/960/1200)
import team360Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-360w.webp.asset.json";
import team480Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-480w.webp.asset.json";
import team640Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-640w.webp.asset.json";
import team768Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-768w.webp.asset.json";
import team960Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-960w.webp.asset.json";
import team1200Webp from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-1200w.webp.asset.json";
import team360Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-360w.avif.asset.json";
import team480Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-480w.avif.asset.json";
import team640Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-640w.avif.asset.json";
import team768Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-768w.avif.asset.json";
import team960Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-960w.avif.asset.json";
import team1200Avif from "@/assets/team/destination-roofing-owner-sales-team-crystal-river-fl-1200w.avif.asset.json";

import trailer480 from "@/assets/destination-roofing-owner-dump-trailer-crystal-river-fl-480w.webp.asset.json";
import trailer768 from "@/assets/destination-roofing-owner-dump-trailer-crystal-river-fl-768w.webp.asset.json";
import trailer1200 from "@/assets/destination-roofing-owner-dump-trailer-crystal-river-fl-1200w.webp.asset.json";
import trailer1320 from "@/assets/destination-roofing-owner-dump-trailer-crystal-river-fl-1320w.webp.asset.json";

import pineridge480 from "@/assets/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-480w.webp.asset.json";
import pineridge768 from "@/assets/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-768w.webp.asset.json";
import pineridge1200 from "@/assets/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1200w.webp.asset.json";
import pineridge1320 from "@/assets/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1320w.webp.asset.json";

const srcset = (a: { url: string }, b: { url: string }, c: { url: string }) =>
  `${a.url} 640w, ${b.url} 1024w, ${c.url} 1600w`;

const heroSrcset = (
  a: { url: string }, b: { url: string }, c: { url: string },
  d: { url: string }, e: { url: string }, f: { url: string },
) => `${a.url} 480w, ${b.url} 640w, ${c.url} 768w, ${d.url} 1024w, ${e.url} 1280w, ${f.url} 1600w`;

const teamSrcset = (
  a: { url: string }, b: { url: string }, c: { url: string },
  d: { url: string }, e: { url: string }, f: { url: string },
) => `${a.url} 360w, ${b.url} 480w, ${c.url} 640w, ${d.url} 768w, ${e.url} 960w, ${f.url} 1200w`;

const webpSrcset4 = (a: { url: string }, b: { url: string }, c: { url: string }, d: { url: string }) =>
  `${a.url} 480w, ${b.url} 768w, ${c.url} 1200w, ${d.url} 1320w`;

export const HERO_CREW = {
  fallback: crew1024Webp.url,
  avif: heroSrcset(crew480Avif, crew640Avif, crew768Avif, crew1024Avif, crew1280Avif, crew1600Avif),
  webp: heroSrcset(crew480Webp, crew640Webp, crew768Webp, crew1024Webp, crew1280Webp, crew1600Webp),
  preloadHref: crew768Avif.url,
  preloadImgSrcset: heroSrcset(crew480Avif, crew640Avif, crew768Avif, crew1024Avif, crew1280Avif, crew1600Avif),
  width: 1600,
  height: 1100,
};

export const METAL_INSTALL = {
  fallback: metal1600Webp.url,
  avif: srcset(metal640Avif, metal1024Avif, metal1600Avif),
  webp: srcset(metal640Webp, metal1024Webp, metal1600Webp),
  width: 1600,
  height: 1100,
};

export const WHITE_METAL_AERIAL = {
  fallback: white1600Webp.url,
  avif: srcset(white640Avif, white1024Avif, white1600Avif),
  webp: srcset(white640Webp, white1024Webp, white1600Webp),
  width: 1600,
  height: 1100,
};

// Real project photos
export const BLUE_METAL_LECANTO = {
  fallback: blue1200.url,
  webp: webpSrcset4(blue480, blue768, blue1200, blue1320),
  width: 1200,
  height: 887,
};

export const GALVALUME_INVERNESS = {
  fallback: galv1200.url,
  webp: webpSrcset4(galv480, galv768, galv1200, galv1320),
  width: 1200,
  height: 915,
};

export const OWNER_SALES_TEAM = {
  fallback: team768Webp.url,
  avif: teamSrcset(team360Avif, team480Avif, team640Avif, team768Avif, team960Avif, team1200Avif),
  webp: teamSrcset(team360Webp, team480Webp, team640Webp, team768Webp, team960Webp, team1200Webp),
  width: 1200,
  height: 1032,
};

export const OWNER_DUMP_TRAILER = {
  fallback: trailer1200.url,
  webp: webpSrcset4(trailer480, trailer768, trailer1200, trailer1320),
  width: 1200,
  height: 883,
};

export const TAN_STANDING_SEAM_PINE_RIDGE = {
  fallback: pineridge1200.url,
  webp: webpSrcset4(pineridge480, pineridge768, pineridge1200, pineridge1320),
  width: 1200,
  height: 658,
};

export type ResponsiveImage = {
  fallback: string;
  webp: string;
  avif?: string;
  width: number;
  height: number;
};

export function ResponsivePicture({
  image,
  alt,
  sizes,
  className,
  imgClassName,
  eager = false,
  fetchpriority,
}: {
  image: ResponsiveImage;
  alt: string;
  sizes: string;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
  fetchpriority?: "high" | "low" | "auto";
}) {
  return (
    <picture className={className}>
      {image.avif && <source type="image/avif" srcSet={image.avif} sizes={sizes} />}
      <source type="image/webp" srcSet={image.webp} sizes={sizes} />
      <img
        src={image.fallback}
        alt={alt}
        width={image.width}
        height={image.height}
        loading={eager ? "eager" : "lazy"}
        decoding={eager ? "sync" : "async"}
        fetchPriority={fetchpriority ?? (eager ? "high" : "auto")}
        className={imgClassName}
        sizes={sizes}
      />
    </picture>
  );
}
